














import Vue from 'vue'
import Authenticated from './helpers/Authenticated.vue'
import OwnerOnly from './helpers/OwnerOnly.vue'
import OwnerMenu from '@/components/owner/OwnerMenu.vue'
import OwnerProfile from '@/components/owner/OwnerProfile.vue'
import OwnerStaff from '@/components/owner/OwnerStaff.vue'
import OwnerAccessCodes from '@/components/owner/OwnerAccessCodes.vue'

export default Vue.extend({
  name: 'OwnerScreen',
  props: {
    restaurantId: String,
  },
  components: { Authenticated, OwnerOnly, OwnerMenu, OwnerProfile, OwnerStaff, OwnerAccessCodes },
  data() {
    return {
      routeName: this.$router.currentRoute.name,
    }
  },
  watch: {
    $route(to) {
      this.routeName = to.name
    },
  },
})
